/*
 * Copyright (c) Schrocken Inc.
 * Author: Harish D
 * File Description: Reducer file for Batch items
 */

import {
  CMO_LINE_BATCH_ITEMS,
  CMO_ADD_BATCH_ITEM,
  CMO_ADD_BATCH_WARNING,
  CMO_BATCH_ITEM_DATES,
  CMO_BATCH_STATUS_LIST,
  CMO_BATCH_UPDATE,
  CMO_ADD_SASL_BATCH_ITEM

} from "../../actions/types";

const initialState = {};

export default function (state = initialState, action) {
  switch (action.type) {
    case CMO_LINE_BATCH_ITEMS:
      return {
        ...state,
        batchItemAdded: false,
        batchWarning: false,
        lineBatchItems: action.payload
      };
    case CMO_BATCH_ITEM_DATES:
      return {
        ...state,
        batchDates: action.payload
      };
    case CMO_ADD_BATCH_ITEM:
      return {
        ...state,
        batchItemAdded: action.payload,
        batchWarning: false
      };
    case CMO_ADD_SASL_BATCH_ITEM:
      return {
        ...state,
        batchSASLAdded: action.payload,
      }

    case CMO_ADD_BATCH_WARNING:
      return {
        ...state,
        batchWarning: action.payload
      };
    case CMO_BATCH_STATUS_LIST:
      return {
        ...state,
        batchStatusList: action.payload
      };

    case CMO_BATCH_UPDATE:
      return {
        ...state,
        batchUpdated: action.payload
      };
    default:
      return state;
  }
}
